import TextButton from "@/components/common/buttons/textButton";

type Props = {
  timer: number;
  onClick: () => void;
};

export default function SendNewCodeButton({ timer, onClick }: Props) {
  return (
    <TextButton onClick={onClick} disabled={timer > 0}>
      {`Send a new code
      ${timer ? ` (0:${timer.toString().padStart(2, "0")})` : ""}`}
    </TextButton>
  );
}
